import React, { useEffect, useContext } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';
import { Context as AuthContext } from '../contexts/authContext';
import { MDBox } from 'components/MDBox';
import { MDTypography } from 'components/MDTypography';
import { IllustrationLayout } from 'components/layout/IllustrationLayout';
import bgImage from '../assets/images/illustrations/illustration-reset.jpg';

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default function VerifyEmailPage() {
  const query = useQuery();
  const history = useHistory();
  const token = query.get('token');
  const { verifyEmail, errors, isLoading, user } = useContext(AuthContext);

  useEffect(() => {
    if (token && verifyEmail) {
      verifyEmail(token);
    }
  }, [token]);

  useEffect(() => {
    if (user && user.token) {
      history.push('/');
    }
  }, [user, history]);

  const err = errors?.serverError;

  return (
    <IllustrationLayout
      title="Verify Email"
      description="Verifying your email address..."
      illustration={bgImage}
    >
      <MDBox
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="200px"
      >
        {isLoading ? (
          <>
            <CircularProgress color="inherit" />
            <MDBox mt={2}>
              <MDTypography variant="h6">Verifying details...</MDTypography>
            </MDBox>
          </>
        ) : err ? (
          <>
            <MDTypography variant="h5" color="error" gutterBottom>
              Verification Failed
            </MDTypography>
            <MDTypography variant="body1" align="center">
              {err}
            </MDTypography>
            <MDBox mt={2}>
              <MDTypography variant="body2" align="center">
                For any issue please contact FairFare support team at support@fairfare.co
              </MDTypography>
            </MDBox>
          </>
        ) : (
          <MDTypography variant="h6">Redirecting...</MDTypography>
        )}
      </MDBox>
    </IllustrationLayout>
  );
}
